import { create } from "zustand";
import { devtools } from "zustand/middleware";
import http from "@/lib/http";
import { toast } from "sonner";

const useLiquidityStore = create(
  devtools((set) => ({
    liquidityData:{},
    liqLoading:false,
    // data structure:
    // totalLiquidity: totalLiquidity the is in reserve currently locked
    // availableLiquidity: full if now unlocked
    // launchTime: time when the lock started 
    // unlockTime: time when liquidity will be available

    getLiquidityStatus: async () => {
      set({ liqLoading: true });
      try {
        const {data} = await http.get("/public/reserveBalance/get-liquidity-status");
        set({
          liquidityData: data.liquidity,
          liqLoading: false,
        });
        return data.liquidity;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || "Failed to fetch data";
        set({loading: false });
        toast.error(errorMessage);
      }
    },
  })),
);

export default useLiquidityStore;
